/**
 * @file productDetails
 * @author WenCe
 */

import {
    GET_CMSAPI_PRODUCT_DETAIL_INDEX,
    GET_CMSAPI_PRODUCT_DETAIL_LIST,
    GET_CMSAPI_PRODUCT_MORE_DETAIL_LIST
} from '../actions/ActionTypes';

export function cmsapiProductDetailIndexData(state = {}, {type, data}) {
    const curPage = 'cur_page';
    const totalPage = 'total_page';
    switch (type) {
        case GET_CMSAPI_PRODUCT_DETAIL_INDEX:
            return {...data};
        case GET_CMSAPI_PRODUCT_DETAIL_LIST:
            return {...state, itemlist: {...state.itemlist, ...data.itemlist}};
        case GET_CMSAPI_PRODUCT_MORE_DETAIL_LIST:
            state.itemlist.article_list.datalist = [
                ...state.itemlist.article_list.datalist,
                ...data.itemlist.article_list.datalist];

            state.itemlist.article_list[curPage] = data.itemlist.article_list.cur_page;
            state.itemlist.article_list[totalPage] = data.itemlist.article_list.total_page;
            return {...state};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/productDetail.js